import { parsePhoneNumberFromString } from "libphonenumber-js";

const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function DataValidators(values: any) {
  let errors: any = {};

  if (!values.email) {
    errors.email = "El email es requerido";
  }

  if (values.email && !rEmail.test(values.email)) {
    errors.email = "El email ingresado es inválido";
  }

  if (!values.phone_number) {
    errors.phone_number = "Campo requerido";
  }

  if (values.phone_number && !/^\d+$/.test(values.phone_number)) {
    errors.phone_number = "Solo debes incluir números";
  }

  if (values.phone_number && values.phone_number.length > 10) {
    errors.phone_number = "Máximo 10 números";
  }

  const phoneNumber = parsePhoneNumberFromString(values.phone_number, "AR");

  if (values.phone_number && !phoneNumber?.isValid()) {
    errors.phone_number = "El número telefónico ingresado es inválido";
  }

  if (!values.full_name) {
    errors.full_name = "Tu nombre y apellido es requerido";
  }

  if (
    values.identification_number &&
    values.identification_number.length > 15
  ) {
    errors.identification_number = "El número de identificación es inválido";
  }

  if (
    values.identification_number &&
    !/^\d+$/.test(values.identification_number)
  ) {
    errors.identification_number = "Solo debes incluir números";
  }

  if (values.identification_number && values.identification_number[0] === "0") {
    errors.identification_number =
      "No incluyas el 0 al inicio de tu número de documento";
  }

  if (!values.identification_number) {
    errors.identification_number = "Tu Nº de documento es requerido";
  }

  return errors;
}
